( function () {
	'use strict';

	/* @ngInject */
	function groupIndexService ( CURRENT_GROUPINDEX ) {
		function setIndex ( newIndex ) {
			CURRENT_GROUPINDEX = {
				'index' : newIndex
			};
		}

		function setContainer ( container ) {
			CURRENT_GROUPINDEX = container;
		}

		function getIndex () {
			return CURRENT_GROUPINDEX.index;
		}

		return {
			'setIndex'     : setIndex,
			'getIndex'     : getIndex,
			'setContainer' : setContainer
		};
	}

	angular
		.module( 'app.templates' )
		.value( 'CURRENT_GROUPINDEX', 0 )
		.factory( 'groupIndexService', groupIndexService );
} )( );
